import { PartnerStore } from "../models/partner-store";
import { httpGet } from "./http-client";

const apiUrl = '/api/partnerstores';

export const getPartnerStores = () => httpGet<PartnerStore[]>(apiUrl);
